class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.initAccessibility();
    this.setupEventListeners();
  }

  initAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.setAttribute('aria-expanded', 'false');

    cartLink.addEventListener('click', (e) => {
      e.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (e) => {
      if (e.code.toUpperCase() === 'SPACE') {
        e.preventDefault();
        this.open(cartLink);
      }
    });
  }

  setupEventListeners() {
    this.addEventListener('keyup', (e) => e.code === 'Escape' && this.close());

    const overlay = document.querySelector('.cart-drawer__left-overlay');
    if (overlay) {
      overlay.addEventListener('click', () => {
        this.close();
      });
    }

    const drawerInner = this.querySelector('.cart-drawer__content');
    if (drawerInner) {
      drawerInner.addEventListener('click', (e) => e.stopPropagation());
    }
  }

  async open(triggeredBy = null) {
    const drawer = document.querySelector('#cart-drawer');
    if (triggeredBy) {
      this.setActiveElement(triggeredBy);
      triggeredBy.setAttribute('aria-expanded', 'true');
    }

    // Primero mostrar el drawer
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('active');
    drawer.style.transform = 'translateX(0)';
    document.body.classList.add('overflow-hidden');

    const overlay = document.querySelector('.cart-drawer__left-overlay');
    if (overlay) {
      overlay.classList.add('active');
      overlay.style.transform = 'translateX(0)';
      overlay.style.opacity = '1';
    }

    // Luego actualizar el contenido
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      // Actualizar el contenido del drawer
      const cartContent = drawer.querySelector('.cart-drawer__content');
      if (cartContent) {
        if (cart.item_count === 0) {
          cartContent.innerHTML = `
            <div class="cart-drawer__empty">
              <p>Tu cesta está vacía</p>
              <a href="/collections/all" class="button">Continuar comprando</a>
            </div>
          `;
        } else {
          // Actualizar totales y contadores
          document.getElementById('cart-item-count').textContent = cart.item_count;
          const cartTotal = drawer.querySelector('.cart-drawer__subtotal span:last-child');
          if (cartTotal) {
            cartTotal.textContent = `${(cart.total_price / 100).toFixed(2)}€`;
          }

          // Actualizar cantidades y subtotales de items
          cart.items.forEach(item => {
            const itemRow = drawer.querySelector(`[data-item-key="${item.key}"]`);
            if (itemRow) {
              const subtotalElement = itemRow.querySelector('.js-item-subtotal');
              if (subtotalElement) {
                subtotalElement.textContent = `$ ${(item.final_line_price / 100).toFixed(2)}`;
              }
              
              const quantityInput = itemRow.querySelector('.cart-drawer__quantity-input');
              if (quantityInput) {
                quantityInput.value = item.quantity;
              }
            }
          });
        }
      }
    } catch (error) {
      console.error('Error actualizando el carrito:', error);
    }

    // Configurar el focus y los event listeners
    drawer.addEventListener('transitionend', () => {
      const focusContainer = drawer.querySelector('.cart-drawer__content') || drawer;
      const focusElement = drawer.querySelector('.cart-drawer__close') || focusContainer;
      trapFocus(focusContainer, focusElement);
    }, { once: true });
  }

  close() {
    const drawer = document.querySelector('#cart-drawer');
    // Move focus to a safe element before hiding the drawer
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (cartLink) {
      cartLink.focus();
      cartLink.setAttribute('aria-expanded', 'false');
    } else {
      document.body.focus();
    }

    drawer.style.transform = 'translateX(100%)';
    document.body.classList.remove('overflow-hidden');
    
    const overlay = document.querySelector('.cart-drawer__left-overlay');
    if (overlay) {
        overlay.style.transform = 'translateX(-100%)';
        overlay.style.opacity = '0';
        
        overlay.addEventListener('transitionend', function handler() {
            overlay.classList.remove('active');
            overlay.removeEventListener('transitionend', handler);
        }, { once: true });
    }

    drawer.classList.remove('active');
    drawer.setAttribute('aria-hidden', 'true');
    
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    const cartDrawerContent = document.querySelector('#cart-drawer');
    if (!cartDrawerContent) return;

    const html = this.getSectionInnerHTML(parsedState.sections['cart-drawer'], '#cart-drawer');
    cartDrawerContent.innerHTML = html;

    // Reconfigurar los event listeners después de actualizar el contenido
    this.setupEventListeners();

    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)?.innerHTML || '';
  }

  getSectionsToRender() {
    return [
      { id: 'cart-drawer', selector: '#cart-drawer' },
      { id: 'cart-icon-bubble' }
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

document.addEventListener('DOMContentLoaded', () => {
  const cartDrawerElement = document.querySelector('#cart-drawer');
  if (cartDrawerElement) {
    window.cartDrawerInstance = cartDrawerElement instanceof CartDrawer
      ? cartDrawerElement
      : new CartDrawer();
  }
});

document.addEventListener('DOMContentLoaded', function () {
  // Manejar el envío del formulario
  document.querySelectorAll('form[data-ajax-cart]').forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const submitButton = form.querySelector('[type="submit"]');
      const originalText = submitButton.textContent;
      
      submitButton.disabled = true;
      submitButton.textContent = 'Agregando...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(Object.fromEntries(new FormData(form)))
      })
      .then(response => response.json())
      .then(data => {
        submitButton.textContent = 'Agregado a la Cesta';
        
        // Actualizar el contador del carrito y abrir el drawer
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            document.getElementById('cart-item-count').textContent = cart.item_count;
            
            // Obtener el HTML actualizado del carrito
            fetch('/?section_id=cart-drawer')
              .then(response => response.text())
              .then(responseText => {
                const parser = new DOMParser();
                const html = parser.parseFromString(responseText, 'text/html');
                const cartDrawerContent = html.getElementById('cart-drawer');
                
                // Actualizar el contenido del drawer
                const currentDrawer = document.getElementById('cart-drawer');
                if (currentDrawer && cartDrawerContent) {
                  currentDrawer.innerHTML = cartDrawerContent.innerHTML;
                }
                
                // Abrir el drawer
                if (window.cartDrawerInstance) {
                  window.location.reload();
                }
              });
          });

        setTimeout(() => {
          submitButton.disabled = false;
          submitButton.textContent = originalText;
        }, 2000);
      })
      .catch(error => {
        console.error('Error:', error);
        submitButton.textContent = 'Error al agregar';
        setTimeout(() => {
          submitButton.disabled = false;
          submitButton.textContent = originalText;
        }, 2000);
      });
    });
  });

  // Escucha los clicks en los botones de aumentar/disminuir cantidad
  document.body.addEventListener('click', function (e) {
    if (e.target.classList.contains('js-quantity-increase') || e.target.classList.contains('js-quantity-decrease')) {
      e.preventDefault();
      
      const input = e.target.closest('td').querySelector('.cart-drawer__quantity-input');
      let quantity = parseInt(input.value, 10);
      
      if (e.target.classList.contains('js-quantity-increase')) {
        quantity += 1;
      } else if (e.target.classList.contains('js-quantity-decrease')) {
        quantity -= 1;
      }

      if (quantity >= 0) {
        input.value = quantity;
        handleQuantityChange(input);
      }
    }
  });

  // Escucha cambios directos en el input de cantidad
  document.body.addEventListener('change', function (e) {
    if (e.target.classList.contains('cart-drawer__quantity-input')) {
      handleQuantityChange(e.target);
    }
  });

  function handleQuantityChange(input) {
    const quantity = parseInt(input.value, 10);
    const itemKey = input.dataset.itemKey;
    const itemPrice = parseFloat(input.dataset.itemPrice);
    const row = input.closest('tr');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: quantity
      })
    })
    .then(response => response.json())
    .then(cart => {
      // Actualizar contador del carrito
      document.getElementById('cart-item-count').textContent = cart.item_count;

      // Si la cantidad es 0, eliminar la fila
      if (quantity === 0 && row) {
        row.remove();
      }

      // Actualizar subtotal
      const subtotalElement = row?.querySelector('.js-item-subtotal');
      if (subtotalElement && quantity > 0) {
        const itemSubtotal = (quantity * itemPrice / 100).toFixed(2);
        subtotalElement.textContent = `${itemSubtotal}€`;
      }

      // Actualizar total del carrito
      const cartTotal = document.querySelector('.cart-drawer__subtotal span:last-child');
      if (cartTotal) {
        cartTotal.textContent = `${(cart.total_price / 100).toFixed(2)}€`;
      }

      // Mostrar mensaje de carrito vacío si corresponde
      if (cart.item_count === 0) {
        const cartContent = document.querySelector('.cart-drawer__content');
        if (cartContent) {
          cartContent.innerHTML = `
            <div class="cart-drawer__empty">
              <p>Tu cesta está vacía</p>
              <a href="/collections/all" class="button">Continuar comprando</a>
            </div>
          `;
        }
      }
    })
    .catch(error => console.error('Error:', error));
  }
});

